// 按需导出用户相关的接口数据
import axios from '../utils/request'
// 传送用户信息
export const login = function (data) {
  return axios({
    method: 'post',
    url: '/api/v1/auth/login',
    data
  })
}
export const loginOut = function (data) {
  return axios({
    method: 'get',
    url: '/api/v1/auth/logout'
  })
}
// 获取验证码图片
export const getCode = function (data) {
  return axios({
    method: 'post',
    url: '/api/v1/public/open/validateCode',
    data
  })
}
// 判断是否是超管
export const isAdmin = function (params) {
  return axios({
    method: 'get',
    url: '/api/v1/web/manager/isAdmin',
    params
  })
}
